import {
    RESET_CUSTOMER_ACTION_STATE,
    RESET_CUSTOMER_STATE,
    GET_CUSTOMER_LISTING,
    GET_CUSTOMER_LISTING_SUCCESS,
    GET_CUSTOMER_LISTING_FAIL,
    GET_CUSTOMER_DETAILS,
    GET_CUSTOMER_DETAILS_SUCCESS,
    GET_CUSTOMER_DETAILS_FAIL,
    UPDATE_CUSTOMER,
    UPDATE_CUSTOMER_SUCCESS,
    UPDATE_CUSTOMER_FAIL,
    CUSTOMER_ACTIVATION,
    CUSTOMER_ACTIVATION_SUCCESS,
    CUSTOMER_ACTIVATION_FAIL,
    GET_CUSTOMER_HISTORY_LISTING,
    GET_CUSTOMER_HISTORY_LISTING_SUCCESS,
    GET_CUSTOMER_HISTORY_LISTING_FAIL,
    EXPORT_CUSTOMER_LISTING,
    EXPORT_CUSTOMER_LISTING_SUCCESS,
    EXPORT_CUSTOMER_LISTING_FAIL,
    SWITCH_CUSTOMER_DOCTOR_FAIL,
    SWITCH_CUSTOMER_DOCTOR,
    SWITCH_CUSTOMER_DOCTOR_SUCCESS,
    DELETE_CUSTOMER,
    DELETE_CUSTOMER_SUCCESS,
    DELETE_CUSTOMER_FAIL,
    CREATE_CUSTOMER,
    CREATE_CUSTOMER_SUCCESS,
    CREATE_CUSTOMER_FAIL,
    GET_CUSTOMER_ORDERS_LISTING,
    GET_CUSTOMER_ORDERS_LISTING_SUCCESS,
    GET_CUSTOMER_ORDERS_LISTING_FAIL,
} from "./actionTypes";

export const getCustomerListing = (data) => ({
    type: GET_CUSTOMER_LISTING,
    payload: data,
});

export const getCustomerListingSuccess = data => ({
    type: GET_CUSTOMER_LISTING_SUCCESS,
    payload: data,
});

export const getCustomerListingFail = error => ({
    type: GET_CUSTOMER_LISTING_FAIL,
    payload: error,
});

export const getCustomerDetails = (data) => ({
    type: GET_CUSTOMER_DETAILS,
    payload: data,
});

export const getCustomerDetailsSuccess = (data) => ({
    type: GET_CUSTOMER_DETAILS_SUCCESS,
    payload: data,
});

export const getCustomerDetailsFail = (error) => ({
    type: GET_CUSTOMER_DETAILS_FAIL,
    payload: error,
});

export const getCustomerHistory = (data) => ({
    type: GET_CUSTOMER_HISTORY_LISTING,
    payload: data,
});

export const getCustomerHistorySuccess = (data) => ({
    type: GET_CUSTOMER_HISTORY_LISTING_SUCCESS,
    payload: data,
});

export const getCustomerHistoryFail = (error) => ({
    type: GET_CUSTOMER_HISTORY_LISTING_FAIL,
    payload: error,
});

export const getCustomerOrderListing = (data) => ({
    type: GET_CUSTOMER_ORDERS_LISTING,
    payload: data,
});

export const getCustomerOrderListingSuccess = (data) => ({
    type: GET_CUSTOMER_ORDERS_LISTING_SUCCESS,
    payload: data,
});

export const getCustomerOrderListingFail = (error) => ({
    type: GET_CUSTOMER_ORDERS_LISTING_FAIL,
    payload: error,
});

export const createCustomer = (data) => ({
    type: CREATE_CUSTOMER,
    payload: data,
});

export const createCustomerSuccess = (data) => ({
    type: CREATE_CUSTOMER_SUCCESS,
    payload: data,
});

export const createCustomerFail = (error) => ({
    type: CREATE_CUSTOMER_FAIL,
    payload: error,
});

export const updateCustomer = (data) => ({
    type: UPDATE_CUSTOMER,
    payload: data,
});

export const updateCustomerSuccess = (data) => ({
    type: UPDATE_CUSTOMER_SUCCESS,
    payload: data,
});

export const updateCustomerFail = (error) => ({
    type: UPDATE_CUSTOMER_FAIL,
    payload: error,
});

export const deleteCustomer = (data) => ({
    type: DELETE_CUSTOMER,
    payload: data,
});

export const deleteCustomerSuccess = (data) => ({
    type: DELETE_CUSTOMER_SUCCESS,
    payload: data,
});

export const deleteCustomerFail = (error) => ({
    type: DELETE_CUSTOMER_FAIL,
    payload: error,
});

export const customerActivation = (data) => ({
    type: CUSTOMER_ACTIVATION,
    payload: data,
});

export const customerActivationSuccess = (data) => ({
    type: CUSTOMER_ACTIVATION_SUCCESS,
    payload: data,
});

export const customerActivationFail = (error) => ({
    type: CUSTOMER_ACTIVATION_FAIL,
    payload: error,
});

export const switchCustomerDoctor = (data) => ({
    type: SWITCH_CUSTOMER_DOCTOR,
    payload: data,
});

export const switchCustomerDoctorSuccess = (data) => ({
    type: SWITCH_CUSTOMER_DOCTOR_SUCCESS,
    payload: data,
});

export const switchCustomerDoctorFail = (error) => ({
    type: SWITCH_CUSTOMER_DOCTOR_FAIL,
    payload: error,
});

export const exportCustomerListing = (data) => ({
    type: EXPORT_CUSTOMER_LISTING,
    payload: data,
});

export const exportCustomerListingSuccess = (data) => ({
    type: EXPORT_CUSTOMER_LISTING_SUCCESS,
    payload: data,
});

export const exportCustomerListingFail = (error) => ({
    type: EXPORT_CUSTOMER_LISTING_FAIL,
    payload: error,
});

//reset
export const resetCustomerActionState = () => {
    return {
        type: RESET_CUSTOMER_ACTION_STATE,
    }
}
export const resetCustomerState = () => {
    return {
        type: RESET_CUSTOMER_STATE,
    }
}

